var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProdutos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.216,
    height: 13.52,
    viewBox: "0 0 19.216 13.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(0 -8.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3047",
    "data-name": "Grupo 3047",
    transform: "translate(0 8.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2244",
    "data-name": "Caminho 2244",
    d: "M22.737,8.061h-9.6a.242.242,0,0,0-.214.155l-.577,1.731a.111.111,0,0,0,.112.155H23.417a.111.111,0,0,0,.112-.155l-.577-1.731A.243.243,0,0,0,22.737,8.061Z",
    transform: "translate(-7.977 -8.061)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2245",
    "data-name": "Caminho 2245",
    d: "M1.993,13.973.023,16.965c-.05.076-.017.128.072.118l2.968-.344a.293.293,0,0,0,.22-.171l.973-2.578a.105.105,0,0,0-.105-.153h-1.9A.34.34,0,0,0,1.993,13.973Z",
    transform: "translate(0 -11.796)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2246",
    "data-name": "Caminho 2246",
    d: "M47.842,17.867,46.1,14.8a.558.558,0,0,0-.231-.2l-1.467-.61c-.083-.035-.126.007-.1.092l.9,2.576a.434.434,0,0,0,.2.22l2.368,1.063C47.856,17.979,47.886,17.945,47.842,17.867Z",
    transform: "translate(-28.646 -11.888)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2247",
    "data-name": "Caminho 2247",
    d: "M8.1,22.16l-.511,2.7a.13.13,0,0,0,.133.16H21.9a.131.131,0,0,0,.134-.16l-.486-2.7A.2.2,0,0,0,21.355,22H8.3A.2.2,0,0,0,8.1,22.16Z",
    transform: "translate(-4.909 -17.076)",
    fill: "#64c2c8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2248",
    "data-name": "Caminho 2248",
    d: "M10.094,32.626H22.663a.144.144,0,0,1,.147.162l-.457,4.518a.185.185,0,0,1-.18.163H10.638a.187.187,0,0,1-.182-.162l-.508-4.518A.143.143,0,0,1,10.094,32.626Z",
    transform: "translate(-6.434 -15.887)",
    fill: "#64c2c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdutos);
export default __webpack_public_path__ + "static/media/produtos.e367b673247b9ec6e4c77c217d66ecd2.svg";
export { ForwardRef as ReactComponent };